import React from 'react';
import { LinkButton } from 'ui/components/styled';

import { Wrapper } from './styles';

export default function EmptyCompanies() {
  return (
    <Wrapper>
      <p>There are no companies please create one</p>
      <div>
        <LinkButton my="m" to="/companies">
          Companies
        </LinkButton>
      </div>
    </Wrapper>
  );
}
